export function parseContentDispositionFilename(header, fallback) {
    if (!header)
        return fallback;
    const match = /filename="([^"]+)"/.exec(header);
    return match?.[1] ?? fallback;
}
//# sourceMappingURL=siteExport.js.map